import { collateOrangePayResponses, } from '../components/addcreditcard/credit-card-form/constants';
import { getPaymentsErrorCode } from './payments';
export const newrelic = {
    addPageAction: (name, value) => {
        var _a;
        if (typeof window !== 'undefined' &&
            ((_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction) instanceof Function) {
            window.newrelic.addPageAction(name, value);
        }
    },
};
export function createNewRelicActions(moduleName) {
    return {
        TOKEN_REQ: `${moduleName}-token-requested`,
        LOAD: `${moduleName}-load`,
        REMOTE_AUTH_CALL: `${moduleName}-remote-auth-call`,
        SUBMIT: `${moduleName}-submit`,
        ERR_CODE: `${moduleName}-error-code`,
        ERR_MSG: `${moduleName}-error-message`,
        PROFILE_REQ: `${moduleName}-profile-request`,
        GET_PAYMENT: `${moduleName}-get-payment-by-id`,
        INFO: `${moduleName}-info`,
        UNCAUGHT: `${moduleName}-uncaught`,
        GET_RSA_PUBLIC_KEY: `${moduleName}-get-rsa-public-key`,
    };
}
export const trackOrangePayNewRelic = (name, response, result = '') => {
    const value = {
        reasonCode: response.reasonCode,
        sessionUuid: response.sessionUuid,
    };
    if (result !== '') {
        value.result = result;
    }
    newrelic.addPageAction(name, value);
};
export const isIframeLoadTimeoutIssue = (err) => {
    return err.message.toLowerCase().includes('timeout');
};
export const trackNewRelicError = (err, pageAction) => {
    const errorDetails = 'isAxiosError' in err && err.isAxiosError
        ? { errorCode: getPaymentsErrorCode(err) || err.code || '' }
        : { errMessage: err.message };
    newrelic.addPageAction(pageAction, Object.assign(Object.assign({}, errorDetails), { result: 'error' }));
};
export const collateReasonCodes = (response, pageAction) => {
    const sessionId = response.sessionUuid;
    if (!sessionId)
        return;
    createErrorTrackingSession(sessionId, pageAction);
    const errorCode = response.reasonCode;
    if (errorCode) {
        addErrorCodeToSession(sessionId, errorCode);
    }
};
const errorSessionMap = new Map();
const hasCardNotFoundCode = (collectedErrors) => {
    const CARD_NOT_FOUND_CODES = collateOrangePayResponses.CARD_NOT_FOUND;
    return collectedErrors.some((errorCode) => CARD_NOT_FOUND_CODES.includes(Number(errorCode)));
};
export const createErrorTrackingSession = (sessionId, pageAction) => {
    // If session already exists, we don't start a new one
    if (errorSessionMap.has(sessionId)) {
        return;
    }
    const errorSession = {
        errorCodes: new Set(),
        timeoutId: setTimeout(() => {
            // After 10 seconds, emit collected error codes
            const collectedErrors = Array.from(errorSession.errorCodes);
            if (collectedErrors.length > 0 && hasCardNotFoundCode(collectedErrors)) {
                newrelic.addPageAction(pageAction, {
                    sessionId,
                    errorCodes: collectedErrors,
                    errorCount: collectedErrors.length,
                    result: 'error',
                });
            }
            errorSessionMap.delete(sessionId);
        }, 10000), // 10 seconds
    };
    errorSessionMap.set(sessionId, errorSession);
};
export const cleanupErrorSession = (sessionId) => {
    const errorSession = errorSessionMap.get(sessionId);
    if (errorSession) {
        clearTimeout(errorSession.timeoutId);
        errorSessionMap.delete(sessionId);
    }
};
export const addErrorCodeToSession = (sessionId, errorCode) => {
    const errorSession = errorSessionMap.get(sessionId);
    if (errorSession && errorCode) {
        errorSession.errorCodes.add(errorCode);
    }
};
export const clearAllErrorSessions = () => {
    errorSessionMap.clear();
};
export const NEW_RELIC_REMOTE_PURCHASES_PCIR = 'remote-purchases-pcir';
export const NEW_RELIC_HD_PASS = 'hd-pass-pcir';
export const NEW_RELIC_HD_PASS_CARD_FORM = 'hd-pass-card-form-pcir';
export const NEW_RELIC_CHECKING_PREFIX = 'checking-migration';
export const NEW_RELIC_RSA_PREFIX = 'checking-rsa';
